import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-single-chat2',
  templateUrl: './single-chat2.component.html',
  styleUrls: ['./single-chat2.component.scss']
})
export class SingleChat2Component implements OnInit {
  isCollapsed = true;
  constructor() { }

  ngOnInit(): void {
  }
  slidechat() {
    document.getElementById("show-user-detail").classList.toggle("open-chat-sidebar");
  }

  closechatside() {
    document.getElementById("show-user-detail").classList.remove("open-chat-sidebar");
  }

  slideuserchat() {
    document.getElementById("show-user-detail").classList.toggle("open-user-sidebar");
  }

  closeuserchatside() {
    document.getElementById("show-user-detail").classList.remove("open-user-sidebar");
  }
}
